import { createAction, props } from '@ngrx/store';
import { Sportlink } from './sportlink.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records sportlink'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records sportlink success', 
    props<{ listData: Sportlink[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records sportlink failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record sportlink'
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record sportlink success', 
    props<{ singleData: Sportlink }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record sportlink failure', 
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record sportlink',
    props<{ updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record sportlink success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record sportlink failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state sportlink',
);